<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>Upload Invoice</h2>
    </div>
    <div class="ibox-content">
      <div class="row">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="" class="select-label">Amount</label>
              <div class="input-group">
                <span class="input-group-addon">$</span>
                <input type="text" class="form-control" :value="payment.total_including_gst" disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group-outer">
            <div class="form-group float-label-control" :class="{ 'has-error': errors.has('invoice_number') }">
              <label for="">Invoice Number</label>

              <input type="text" v-validate="'required'" class="form-control" name="invoice_number"
                placeholder="Invoice Number" v-model="number" :disabled="cannotEditInvoice" v-float-label>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div :class="{ 'col-sm-6 col-md-8': canEditInvoice, 'col-sm-12': cannotEditInvoice }">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('invoice_file') }">
                  <label for="">Invoice File (Maximum 3MB)</label>
                  <input
                    name="invoice_file"
                    v-validate="'required'"
                    type="text"
                    class="form-control"
                    placeholder="Invoice File"
                    :value="file"
                    disabled
                    v-float-label>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-4" v-if="canEditInvoice">
              <label class="btn btn-primary btn-sm btn-block m-b-md" for="invoice_file">
                <input
                  type="file"
                  class="sr-only"
                  name="file"
                  id="invoice_file"
                  accept=".jpg,.jpeg,.png,.gif,.pdf"
                  @change="handleFileSelection"
                  :disabled="cannotEditInvoice">
                Select File
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-footer text-right" v-if="canEditInvoice">
      <ladda-button :on-click="handleUploadInvoice" class="btn btn-sm btn-success">Save</ladda-button>
    </div>
  </div>
</template>
<script>
  import { LaddaButton } from 'components/forms'
  import { mapState, mapActions } from 'vuex'
  import { has } from 'lodash'
  import { notify } from 'utils'

  export default {
    components: {
      LaddaButton
    },

    data () {
      return {
        invoice: {
          number: null,
          file: null
        }
      }
    },

    computed: {
      ...mapState('payment', ['payment']),

      canEditInvoice () {
        if (this.$user.isCarrier && has(this.payment, 'invoice.id') && this.payment.invoice.id !== null) {
          return false
        }

        return true
      },

      cannotEditInvoice () {
        return !this.canEditInvoice
      },

      number: {
        get () {
          if (this.invoice.number) {
            return this.invoice.number
          } else if (this.payment.invoice) {
            return this.payment.invoice.number
          }

          return null
        },

        set (value) {
          this.invoice.number = value
        }
      },

      file: {
        get () {
          if (this.invoice.file) {
            return this.invoice.file.name
          } else if (this.payment.invoice) {
            return this.payment.invoice.file_name
          }

          return null
        },

        set (value) {
          this.invoice.file = value
        }
      }
    },

    methods: {
      ...mapActions('payment', ['uploadPaymentInvoice', 'getPayment']),

      /**
       * Handle uploading an invoice.
       *
       * @return void
       */
      handleUploadInvoice () {
        return this.validateAll().then(() => {
          let payload = {
            id: this.payment.id,
            file: this.invoice.file,
            number: this.number
          }

          const refreshPayment = () => {
            return this.getPayment(this.payment.id)
          }

          const handleErrorResponse = error => {
            if (error.response) {
              if (error.response.status === 422) {
                notify.error('There was a problem uploading the invoice, please check the invoice number and file.')
              } else if (error.response.status === 500) {
                notify.error('There was a problem uploading the invoice, please check the invoice file.')
              }
            }
          }

          return this.uploadPaymentInvoice(payload).then(refreshPayment).catch(handleErrorResponse)
        })
      },

      /**
       * Handle changes to the selected file.
       *
       * @param object files
       *
       * @return void
       */
      handleFileSelection ({ target: { files } }) {
        if (files.length === 0) {
          this.file = null

          return
        }

        this.file = files.item(0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ShowUploadInvoice.vue?294c24a8